import gql from "graphql-tag";

export const updateSeenNewsItemMutation = gql`
  mutation UpdateSeenNewsItemMutation($id: [Int!]!) {
    updateSeenNewsItem(id: $id) {
      id
    }
  }
`;
